export const contingentWarningIcon = {
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path d="M6.114 3.5a.114.114 0 11-.228 0 .114.114 0 01.228 0z" fill="#405D69" stroke="#405D69" stroke-width="1.2"/><path d="M6 11A5 5 0 106 1a5 5 0 000 10zM6 8.857V6" stroke="#405D69" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'warning',
};
